// extracted by mini-css-extract-plugin
export default {"modal":"guide-modal_modal__LXHdm","mobile":"guide-modal_mobile__bthv0"};